import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { TranslocoModule } from '@ngneat/transloco';
import { SearchResourcesDialogComponent } from '../search-resources-dialog/search-resources-dialog.component';
import { WorkshiftsService } from '../../modules/admin/workshifts/workshifts.service';
import { LocalizeDatePipe } from '../../core/pipes/localizeDate.pipe';

@Component({
    selector: 'app-workshift-user-events-dialog',
    templateUrl: './workshift-user-events-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
        .edit-workshift-user-events-dialog-panel {

            .mat-mdc-dialog-container {
        
                .mat-mdc-dialog-surface {
                    padding: 0 !important;
                }
            }
        }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [LocalizeDatePipe, MatButtonModule, MatIconModule, MatListModule, TranslocoModule]
})
export class WorkshiftUserEventsDialogComponent {

    public data: { userId: string, workshiftId: string, serviceId: string, userName: string, externalWorkshiftId: string } = inject(MAT_DIALOG_DATA);
    private dialogRef = inject(MatDialogRef<SearchResourcesDialogComponent>);
    private workshiftsService = inject(WorkshiftsService);

    events = toSignal(this.workshiftsService.retrieveWorkshiftUserEventList({ serviceId: this.data.serviceId, userId: this.data.userId, workshiftId: this.data.workshiftId }));

    constructor() {
    }

    closeDialog() {
        this.dialogRef.close();
    }

}
